import { useEffect, useRef, useState } from "react";
import { Eraser, Trash2, Check } from "lucide-react";

const COLORS = ["#1B1A2E", "#FF6B4A", "#FFD23F", "#3DCCC7", "#7B5CFA", "#FF8FC7", "#22A06B", "#8B5A2B"];
const SIZES = [6, 14, 28];

export const ColorSplash = ({ onFinish }) => {
  const canvas = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const [color, setColor] = useState(COLORS[1]);
  const [size, setSize] = useState(SIZES[1]);
  const [eraser, setEraser] = useState(false);
  const [strokes, setStrokes] = useState(0);

  useEffect(() => {
    const c = canvas.current;
    const r = c.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    c.width = r.width * dpr;
    c.height = r.height * dpr;
    const ctx = c.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, r.width, r.height);
  }, []);

  const pos = (e) => { const r = canvas.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { canvas.current.setPointerCapture(e.pointerId); drawing.current = true; last.current = pos(e); move(e); };
  const up = () => { if (drawing.current) setStrokes((s) => s + 1); drawing.current = false; };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvas.current.getContext("2d");
    const [x, y] = pos(e);
    ctx.strokeStyle = eraser ? "#fff" : color;
    ctx.lineWidth = size;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.beginPath();
    ctx.moveTo(...last.current);
    ctx.lineTo(x, y);
    ctx.stroke();
    last.current = [x, y];
  };
  const clear = () => { const c = canvas.current; const ctx = c.getContext("2d"); ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, c.width, c.height); setStrokes(0); };

  return (
    <div className="space-y-3">
      <canvas ref={canvas} data-testid="splash-canvas" onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up}
        className="w-full aspect-square max-h-[52svh] sm:max-h-none sm:aspect-[16/9] rounded-3xl border-[3px] border-[#1B1A2E] bg-white shadow-[4px_4px_0_0_#1B1A2E] touch-none cursor-crosshair" />
      <div className="flex flex-wrap items-center gap-2">
        {COLORS.map((c) => (
          <button key={c} data-testid={`splash-color-${c.slice(1)}`} onClick={() => { setColor(c); setEraser(false); }} aria-label={`color ${c}`}
            className={`w-10 h-10 rounded-full border-[3px] border-[#1B1A2E] ${color === c && !eraser ? "ring-4 ring-[#7B5CFA]" : ""}`} style={{ background: c }} />
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {SIZES.map((s) => (
          <button key={s} data-testid={`splash-size-${s}`} onClick={() => setSize(s)} className={`w-11 h-11 grid place-items-center rounded-full border-[3px] border-[#1B1A2E] ${size === s ? "bg-[#FFD23F]" : "bg-white"}`} aria-label={`brush ${s}`}>
            <span className="rounded-full bg-[#1B1A2E]" style={{ width: s / 1.6 + 4, height: s / 1.6 + 4 }} />
          </button>
        ))}
        <button data-testid="splash-eraser" onClick={() => setEraser((v) => !v)} className={`zn-chip ${eraser ? "bg-[#FFD23F]" : "bg-white"}`}><Eraser size={16} /> Eraser</button>
        <button data-testid="splash-clear" onClick={clear} className="zn-chip bg-white"><Trash2 size={16} /> Clear</button>
        <button data-testid="splash-done" disabled={strokes < 3} onClick={() => onFinish(strokes, strokes >= 30 ? 3 : strokes >= 12 ? 2 : 1)} className="zn-btn bg-[#FF6B4A] text-white !py-2 w-full sm:w-auto sm:ml-auto"><Check size={18} /> I'm done!</button>
      </div>
    </div>
  );
};
